.button {
  margin: 0;
  padding: 0;
  cursor: pointer;
  border: 0;
  border-radius: radius(xs);

  color: var(--button-text-color, #{c(titanium)});
  background-color: var(--button-background-color, transparent);
  padding: spacing(2) var(--padding-x);

  display: inline-flex;
  flex-direction: row;
  column-gap: spacing(8);
  justify-content: center;
  align-items: center;
  text-decoration: none;
  overflow-anchor: none;

  &:visited {
    color: var(--button-text-color);
  }

  &[disabled] {
    cursor: not-allowed;
    pointer-events: none;
    --button-outline-color: var(--button-text-color);
  }

  &:focus-visible {
    outline: 1px solid var(--button-outline-color);
    outline-offset: 2px;
  }
}

.button:not(.size-small) {
  @include font(aux, xs, 600);
  --padding-x: #{spacing(16)};

  min-height: spacing(48);
}

@mixin size-small {
  @include font(aux, xxs, 600);
  --padding-x: #{spacing(12)};
  min-height: spacing(32);
}

.button.size-small {
  @include size-small;
}

.button:not(.inline) {
  text-transform: uppercase;
}

.icon {
  vertical-align: middle;
}

.icon-right {
  padding-left: calc(var(--padding-x) + #{spacing(4)});
}

.icon-left {
  padding-right: calc(var(--padding-x) + #{spacing(4)});
}

.icon-only {
  padding: spacing(12);
}

.button.gap-small {
  column-gap: spacing(4);
}

.no-wrap {
  white-space: nowrap;
  span {
    white-space: nowrap;
  }
}

.button:not(.variant-inline-text).full {
  width: 100%;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.loading {
  position: relative;

  &:before {
    content: "";
    box-sizing: border-box;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 20px;
    height: 20px;
    margin-top: -10px;
    margin-left: -10px;
    border-radius: 50%;
    border: 2px solid currentColor;
    border-top-color: var(--button-text-color);
    animation: spinner 0.6s linear infinite;

    color: c(neutral50);
  }

  > span,
  .icon {
    visibility: hidden;
  }
}

.button.mobile-size-small {
  @include media-breakpoint-down(sm) {
    @include size-small;
  }
}

.button.size-container {
  @container button-size-small (width > 0) {
    @include size-small;
  }
}

.inverted {
  --button-outline-color: #{c("white")};
}

.variant-primary {
  --button-text-color: #{c(yellow03)};
  --button-background-color: #{c(titanium)};
  --button-outline-color: #{c(titanium)};

  &:hover {
    --button-background-color: #{c(neutral60)};
  }

  &[disabled] {
    --button-text-color: #{c(neutral35)};
    --button-background-color: #{c(neutral10)};
  }

  &.inverted {
    --button-text-color: #{c(titanium)};
    --button-background-color: #{c("white")};

    &:hover {
      --button-background-color: #{c(neutral25)};
    }

    &[disabled] {
      --button-text-color: #{c(neutral50)};
      --button-background-color: #{c(neutral60)};
    }
  }
}

.variant-accent {
  --button-text-color: #{c(titanium)};
  --button-background-color: #{c(yellow03)};
  --button-outline-color: #{c(titanium)};

  &:hover {
    --button-background-color: #{c(yellow02)};
  }

  &[disabled] {
    --button-text-color: #{c(neutral35)};
    --button-background-color: #{c(neutral10)};
  }

  &.inverted {
    &[disabled] {
      --button-text-color: #{c(neutral50)};
      --button-background-color: #{c(neutral60)};
    }
  }
}

.variant-secondary {
  --button-background-color: transparent;
  border: 1px solid var(--button-outline-color);

  &:focus-visible {
    outline-offset: 1px;
  }

  &:not(.inverted) {
    --button-text-color: #{c(titanium)};
    --button-outline-color: #{c(titanium)};

    &:hover {
      --button-background-color: #{c(neutral05)};
    }

    &[disabled] {
      --button-text-color: #{c(neutral35)};
      --button-outline-color: #{c(neutral35)};
    }
  }

  &.inverted {
    --button-text-color: #{c("white")};
    --button-outline-color: #{c("white")};

    &:hover {
      --button-background-color: #{c(neutral60)};
    }

    &[disabled] {
      --button-text-color: #{c(neutral50)};
      --button-outline-color: #{c(neutral50)};
    }
  }
}

.variant-elevated {
  --button-background-color: #{c("white")};
  --button-outline-color: #{c("white")};
  --button-text-color: #{c(titanium)};

  box-shadow: shadow(m);

  &:focus-visible {
    outline-offset: 1px;
    --button-outline-color: #{c(titanium)};
  }

  &:hover {
    --button-background-color: #{c(neutral05)};
  }

  &[disabled] {
    --button-text-color: #{c(neutral35)};
    --button-background-color: #{c(neutral10)};
    --button-outline-color: #{c(neutral10)};
  }

  // &:not(.inverted) {
  //   --button-text-color: #{c(titanium)};
  //   --button-outline-color: #{c(titanium)};

  //   &:hover {
  //     --button-background-color: #{c(neutral05)};
  //   }

  //   &[disabled] {
  //     --button-text-color: #{c(neutral35)};
  //   }
  // }

  // &.inverted {
  //   --button-text-color: #{c("white")};
  //   --button-outline-color: #{c("white")};

  //   &:hover {
  //     --button-background-color: #{c(neutral60)};
  //   }

  //   &[disabled] {
  //     --button-text-color: #{c(neutral50)};
  //     --button-text-color: #{c(neutral50)};
  //   }
  // }

  // --button-background-color: #{c("white")};
  // --button-outline-color: #{c("white")};
  // border: 1px solid c("white");
  // box-shadow: shadow(m);

  // &[disabled] {
  //   --button-text-color: #{c(neutral35)};
  //   --button-background-color: #{c(neutral10)};
  // }

  // &.inverted {
  //   --button-text-color: #{c(titanium)};

  //   &:hover {
  //     --button-background-color: #{c(neutral10)};
  //     --button-outline-color: #{c(titanium)};
  //   }
  // }
}

.variant-text {
  --button-text-color: #{c(titanium)};
  --button-background-color: transparent;
  --button-outline-color: #{c(titanium)};

  span {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  &:hover {
    --button-background-color: #{c(neutral05)};
    span {
      text-decoration: none;
    }
  }

  &:focus-visible {
    outline-offset: 1px;
  }

  &:active {
    --button-background-color: transparent;
  }

  &[disabled] {
    --button-text-color: #{c(neutral35)};
    --button-background-color: transparent;
  }

  &.inverted {
    --button-text-color: #{c("white")};

    &:hover {
      --button-background-color: #{c(neutral60)};
    }
  }
}

.variant-inline-text {
  --button-text-color: currentColor;
  --button-background-color: transparent;
  --button-outline-color: currentColor;
  padding: 0;
  min-height: unset !important;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;

  span {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  &:hover {
    span {
      text-decoration: none;
    }
  }

  &:active {
    outline: none;
  }

  &:focus-visible {
    outline-offset: 8px;
  }

  &[disabled] {
    --button-text-color: #{c(neutral35)};
  }
}

.variant-link {
  --button-text-color: currentColor;
  --button-background-color: transparent;
  --button-outline-color: currentColor;
  padding: 0;
  min-height: unset !important;
  height: auto;
  margin-top: auto;
  margin-bottom: auto;
  text-transform: none !important;

  span {
    text-decoration: underline;
    text-underline-offset: 4px;
  }

  &:hover {
    span {
      text-decoration: none;
    }
  }

  &:active {
    outline: none;
  }

  &[disabled] {
    --button-text-color: #{c(neutral35)};
  }
}
